<template>
    <div class="all clearfix">
        <div class="grid newsDetail bgff">
           <div class="grid-d">
                <div class="jianshu">
                    <h2 class="ovhidden">
                        <i class="tag" :class="attributeType[infoList.newsEmotion]">{{infoList.newsEmotion}}</i>
                        <strong class="ml10">{{infoList.newsTitle}}</strong>
                    </h2>
                    <p class="mt5 cr77"><span class="">{{infoList.publishTime}}</span></p>
                    <p class="mt5 cr5e">{{infoList.newsDigest}}</p>
                    <p class="ar "><a class="cr27" :href="infoList.newsUrl" target="_blank"><i class="icons icon-link"></i>相关链接</a></p>
                </div>
            </div>
            <div class="grid-d mt20">
                <div class="grid-header clearfix">
                    <h2 class="title">话题概况</h2>
                </div>
                <div class="grid-body mt15" v-html="hotOver">{{hotOver}}</div>
            </div>
            <div class="grid-d mt20">
                <div class="grid-header clearfix">
                    <h2 class="title">主题脉络</h2>
                </div>
                <div class="grid-body mt15">
                    <ul class="eventLine">
                        <li class="clearfix" v-for="(item,index) in timeLineList" :key="index">
                            <span class="eventLine-time cr80 fl">{{item.news_posttime.slice(5)}}</span>
                            <div class="eventLine-cont">
                                <div class="eventLine-title">
                                    <i class="tag mr6 fl" :class="attributeType[item.news_emotion]">{{item.news_emotion}}</i>
                                    <a :href="item.news_url" class="cr33 fl ovhidden ml10" target="_blank" :title="item.news_title">{{item.news_title}}</a>
                                    <span class="icon-new ml10 fs12" v-if="index===0">新发</span>
                                </div>
                                <p class="mt5 ml10 cr99 fs12">
                                    <span class="pr30">来源：{{item.media_name}}</span>
                                    <span class="pr30 ml20" v-if="item.news_keywords_list!=''">相关词：{{item.news_keywords_list.slice(0,3).join('，')}}</span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">话题走势</h2>
                </div>
                <div class="grid-body mt15">
                    <div class="echart-warp h305">
                        <lineChart id="hotEvent" :dataArray="hotEventData" v-if="hotEventData != ''" :colorArr="colorArr" :isShowArea="false" gridBot ="60"></lineChart>
                        <div class="no-data" v-if="nodata.hotEventData"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div>
            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">平台分析</h2>
                </div>
                <div class="grid-body mt15">
                    <div class="echart-warp h270">
                        <pieChart id="media" :dataArray="mediaData" v-if="mediaData != ''" :colorArr="mediaColorArr"></pieChart>
                        <div class="no-data" v-if="nodata.mediaData"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div>

            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">活跃渠道</h2>
                </div>
                <div class="grid-body mt20">
                    <div class="corm clearfix">
                        <span class="element" v-for="(item,index) in activeAccTab" :key="index" @click="choseAccout(index)" :class="{'curr':curIndex == index}">{{item}}</span>
                    </div>
                    <ul class="strip-shape clearfix">
                        <li class="cp" v-for="(item,index) in activeAccList" :key="index"  @click="artiView(item.name)">
                            <div class="people clearfix fl">
                                <img :src="item.icon == '' ? 'static/images/head_img.png' : item.icon" class="img fl"/>
                                <span class="name ovhidden" :title="item.name">{{item.name}}</span>
                            </div>
                            <div class="number fr">
                                <span class="color-blue">{{item.value}}</span>篇
                            </div>
                            <div class="line-warp clearfix">
                                <div class="line">
                                    <div class="in" :style='{width:""+item.percent+""}'></div>
                                </div>
                            </div>
                        </li>
                    </ul>
                     <div class="no-data data-load" v-if="load.activeAccList"><img src="static/images/loading1.gif" class="img"/><span class="text">获取数据中...</span></div>
                    <div class="no-data" v-if="nodata.activeAccList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                </div>
            </div>
            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">首发文章</h2>
                </div>
                <div class="grid-body pb0 mt15">
                    <ul class="article-list">
                        <li class="imgText clearfix">
                            <!-- <router-link class="img fl cp" :to="{path:'eventDetail',query:{id:firNewsList.id}}" target="_blank"><img :src="firNewsList.icon" :onerror="defaultImg"/></router-link> -->
                             <a class="img fl" :href="firNewsList.news_url" target="_blank" v-if="firNewsList.news_img_urls!=undefined">
                                <img :src="firNewsList.isLoadStart?firNewsList.curImg:imgChose(firNewsList,firNewsList.news_img_urls)" :onerror="defaultImg"/>
                            </a>
                            <div class="hidden">
                                <div class="clearfix mt5">
                                    <h2 class="fl ovhidden2">
                                        <!-- <router-link class="cr00 cp" :to="{path:'eventDetail',query:{id:firNewsList.id}}" target="_blank">{{firNewsList.news_title}}</router-link> -->
                                        <a class="cr00 cp" :href="firNewsList.news_url" target="_blank">{{firNewsList.news_title}}</a>
                                    </h2>
                                </div>
                                <p class="cr5e mt10 ovhidden2">{{firNewsList.news_digest}}</p>
                                <p class="ziduan mt15 cr77">
                                    <!-- <span v-if="firNewsList.news_source!=''">{{firNewsList.news_source}} ·  </span> -->
                                    <span v-if="firNewsList.platform_name!=''"><i class="icons sm-icon mr4" :class="showNewType(firNewsList.news_type,1)"></i>{{firNewsList.platform_name}} · </span>
                                    <span v-if="firNewsList.media_name!=''">{{firNewsList.media_name}}</span>
                                    <span class="ml20">{{timeFilter(firNewsList.news_posttime)}}</span>
                                </p>
                            </div>
                        </li>
                    </ul>                  
                </div>
            </div>
            <div class="grid-d clearfix">
                <div class="md5 fl pr10">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">情感属性</h2>
                        <div class="corm fr clearfix">
                            <span class="element" :class="tuType === 'line' ? 'curr' : ''" @click="emotionEchartTab('line');">趋势图</span>
                            <span class="element" :class="tuType === 'pie' ? 'curr' : ''" @click="emotionEchartTab('pie');">饼状图</span>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="echart-warp h270" >
                            <div class="no-data" v-if="tuType === 'pie' && nodata.emotionData2"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                            <lineChart id="emotion1" :dataArray="emotionData1" v-if="tuType === 'line' && emotionData1 != ''"></lineChart>
                            <pieChart id="pieEchart1" :dataArray="emotionData2" :colorArr="emotionColorArr" v-if="tuType === 'pie' && emotionData2 != ''"></pieChart>
                        </div>
                    </div>
                </div>
                <div class="md5 fl pl10">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">热门主题词</h2>
                        <div class="collection fr clearfix">
                            <span class="tion drop-down">
                                <button class="btn btn-lightblue">{{curHotTheme}}<i class="icons"></i></button>
                                <ul class="option">
                                    <li @click="hotThemeTab(index);" v-for="(item,index) of mtType" :key="index">{{item}}</li>
                                </ul>
                            </span>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="echart-warp h270">
                            <div class="no-data" v-if="nodata.defaultWords"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                            <cloudChart id="wordCloud" :dataArray="defaultWords" v-if="hotThemeType == 0 && defaultWords!= ''"></cloudChart>
                            <pieChart v-if="hotThemeType == 1 && hotThemePie != ''" id="pieEchart3" :dataArray="hotThemePie" :showLegend="false"></pieChart>
                            <radarChart v-if="hotThemeType == 2 && hotThemeRadar != ''" id="radarEchart" :dataArray="hotThemeRadar"></radarChart>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid-d clearfix">
                <div class="md5 fl pr10">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">发布地区</h2>
                        <div class="collection fr clearfix">
                            <span class="drop-down mores">
                                <button class="btn btn-lightblue">{{curPublishArea}}<i class="icons"></i></button>
                                <ul class="option pl">
                                    <li v-for="(item,index) in areaChoseList" :key="index" @click="changeArea(item,1,index)">{{item}}</li>
                                </ul>
                            </span>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="clearfix">
                            <div class="region mt20 fl">
                                <div class="region-header">
                                    <span class="span fl">地区</span>
                                    <span class="span fl">数量</span>
                                </div>
                                <div class="region-body">
                                    <vue-scroll :ops="ops" style="width:140px;height:246px">
                                        <div class="item" v-for="(item,index) in publishAreaData" :key="index">
                                            <span class="span fl ovhidden">{{item.name}}</span>
                                            <span class="span fl">{{item.value}}</span>
                                        </div>
                                    </vue-scroll>
                                </div>
                            </div>
                            <div class="echart-warp hidden h270">
                                <mapChart id="publishArea" :dataArray="publishAreaData" :areaName="curPublishArea" :isShowChild="false" v-if="publishAreaData != ''"></mapChart>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="md5 fl pl10">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">提及地区</h2>
                        <div class="collection fr clearfix">
                                <span class="drop-down mores">
                                <button class="btn btn-lightblue">{{curMentionArea === 'top' ? '全国' : curMentionArea}}<i class="icons"></i></button>
                                <ul class="option pl">
                                    <li v-for="(item,index) in areaChoseList" :key="index" @click="changeArea(item,2,index)">{{item}}</li>
                                </ul>
                            </span>
                        </div>
                    </div>
                    <div class="grid-body mt15">
                        <div class="clearfix">
                            <div class="region mt20 fl">
                                <div class="region-header">
                                    <span class="span fl">地区</span>
                                    <span class="span fl">数量</span>
                                </div>
                                <div class="region-body">
                                    <vue-scroll :ops="ops" style="width:140px;height:246px">
                                        <div class="item" v-for="(item,index) in mentionAreaData" :key="index">
                                            <span class="span fl ovhidden">{{item.name}}</span>
                                            <span class="span fl">{{item.value}}</span>
                                        </div>
                                    </vue-scroll>
                                </div>
                            </div>
                            <div class="echart-warp hidden h270">
                                <mapChart id="mentionArea" :dataArray="mentionAreaData" :areaName="curMentionArea" :isShowChild="false" v-if="mentionAreaData != ''" ></mapChart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-d clearfix">
                <div class="md5 fl pr10">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">人物实体</h2>
                    </div>
                    <div class="grid-body mt15 h305">
                        <ul class="entity clearfix">
                            <li class="entityLi cp" v-for="(item,index) in entityList" :key="index" @click="showKnow(item)">
                                <span>{{item}}</span>
                            </li>
                        </ul>
                        <div class="no-data" v-if="nodata.entityList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
                 <div class="md5 fl pl10">
                    <div class="grid-header clearfix">
                        <h2 class="title fl">机构实体</h2>
                    </div>
                    <div class="grid-body mt15 h305">
                        <ul class="entity clearfix">
                            <li class="entityLi cp" v-for="(item,index) in institEntityList" :key="index" @click="showKnow(item)">
                                <span>{{item}}</span>
                            </li>
                        </ul>
                        <div class="no-data" v-if="nodata.institEntityList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </div>
                </div>
            </div>
            <div class="grid-d">
                <div class="grid-header clearfix">
                    <h2 class="title">相关文章</h2>
                </div>
                <div class="grid-body pb0 mt15">
                    <ul class="article-list">
                        <li class="imgText clearfix" v-for="(item,index) in commendList" :key="index">
                            <!-- <router-link class="img fl cp" :to="{path:'newsDetail',query:{id:item.id}}" target="_blank">
                                <img :src="item.isLoadStart?item.curImg:imgChose(item)" :onerror="defaultImg"/>
                            </router-link> -->
                            <a class="img fl" :href="item.news_url" target="_blank">
                                <img :src="item.isLoadStart?item.curImg:imgChose(item,item.news_img_urls)" :onerror="defaultImg"/>
                            </a>
                            <div class="hidden">
                                <div class="clearfix mt5">
                                    <h2 class="fl ovhidden">
                                        <!-- <router-link class="cr00 cp" :to="{path:'newsDetail',query:{id:item.id}}" target="_blank">{{item.news_title}}</router-link> -->
                                        <a class="cr00 cp" :href="item.news_url" target="_blank">{{item.news_title}}</a>
                                    </h2>
                                </div>
                                <p class="cr5e mt10 ovhidden2">{{item.news_digest}}</p>
                                <p class="ziduan mt15 cr77">
                                    <!-- <span v-if="item.news_source!=''">{{item.news_source}} ·  </span> -->
                                    <span v-if="item.platform_name!=''"><i class="icons sm-icon mr4" :class="showNewType(item.news_type,1)"></i>{{item.platform_name}} · </span>
                                    <span v-if="item.media_name!=''">{{item.media_name}}</span>
                                    <span class="ml20">{{timeFilter(item.news_posttime)}}</span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 预览 -->
        <Dialog ref="viewModal" :callback="enterView" width="720" title="预览" :modalFoot='false'>
            <div slot="mdBox">
                <div class="artiWrap">
                    <vue-scroll :ops="ops" :style="'height:'+ scrollH">
                        <table width="100%" border="0" cellpadding="0" cellspacing="0" :class="apiSecret?'table1':'table'">
                            <colgroup>
                                <col width="100%">
                            </colgroup>
                            <tbody>
                                <tr v-for="(item,index) in viewList" :key="index">
                                    <td>
                                        <a class="ovhidden" :href="item.news_url" target="_blank">{{item.news_title}}</a>
                                        <p class="mt10 cr77">
                                            <span>{{item.media_name}}</span> 
                                            <span class="ml20">{{item.news_posttime}}</span>
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <ul class="article-list" :style="'height:'+ scrollH">
                            <li v-for="(item,index) in viewList" :key="index">
                                <p class=" mt5"><a class="ovhidden" :href="item.news_url" target="_blank">{{item.news_title}}</a></p>
                                <p class="ziduan mt10 cr77">
                                    <span>{{item.media_name}}</span> 
                                    <span>{{item.news_posttime}}</span>
                                </p>
                            </li>
                        </ul> -->
                        <div class="no-data" v-if="nodata.viewList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </vue-scroll>
                </div>
            </div>
        </Dialog>
        <!-- 知识图谱 -->
        <Dialog ref="knowModal" :callback="enterView" width="1000" title="知识图谱" :modalFoot='false'>
            <div slot="mdBox">
                <div class="artiWrap bg07 h800 hidden">
                    <d3chart id="d3Svg" width="952" height="460" ref="d3" :ds="dsCharts" :updateDs="updateDsCharts" @entityFatherMethod="getEntityChild"></d3chart>
                    <div class="no-data mt0 pt40" v-if="nodata.knowEntity"><img src="static/images/no_data.png" class="img"/><span class="text crff">啥也没有找到，换个词试试吧~</span></div>
                </div>
            </div>
        </Dialog>
    </div>
</template>
<script>
import Myleft from '../../components/left'
import lineChart from '../../components/echart/lineChart.vue';
import pieChart from '../../components/echart/pieChart.vue';
import radarChart from '../../components/echart/radarChart.vue';
import mapChart from '../../components/echart/mapChart.vue';
import cloudChart from '../../components/echart/wordCloud.vue';
import Dialog from '../../components/dialog.vue'
//import '../../../static/js/d3.v4.min.js'
import d3chart from '../../components/d3Chart.vue'
//import '../../../static/js/knowledge.js'
export default {
    components: {Myleft,lineChart,pieChart,radarChart,cloudChart,mapChart,Dialog,d3chart},
    data() {
        return {
            sid : this.$route.query.id,
            newsType : this.$route.query.newsType,
            type : this.$route.query.type,
            apiSecret : this.$route.query.api_secret,
            attributeType:{
                '正面':'tag-blue',
                '中性':'tag-orange',
                '负面':'tag-red',
            },//属性对应的class样式
            hotTopicsList:[],
            defaultImg:'this.src="static/images/default.png"',
            nodata:{
                hotTopicsList:false,
                viewList:false,
            },
            infoList:{},
            title:'',
            beginDate:'',
            description:'',
            hotOver:'',
            timeLineList:[],//时间脉络
            hotEventData:[],
            mediaData:[],
            mediaColorArr:["#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            colorArr:["#56566a","#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"],
            curIndex:'wx',
            activeAccTab:[],
            activeAccList:[],
            wbAnalysisHtml:{},
            wbAnalysisData:[],//微博分析
            curWbType:'个人认证',
            wbTypeList:[],
            bloggerAllList:[],
            bloggerList:[],//影响力博主
            emotionData1:[],//情感属性折线
            emotionData2:[],//情感属性饼图
            tuType:'pie',//控制图表类型
            emotionColorArr:['#0095eb','#ff8121','#e63349'],
            mtType:['词云图','饼图','雷达图'],//媒体类别
            defaultWords:[],//热门主题词词云图
            wordColors: ['#3c77ce', '#bf3a54', '#2fa130', '#ce393a', '#36accd', '#c64c65'],
            curHotTheme:'词云图',
            hotThemePie:[],//热门主题词饼图
            hotThemeRadar:[],
            hotThemeType:0,
            publishAreaData:[],//发布地区
            areaChoseList:[],
            provinceFullList:[],
            curPublishArea:'全国',
            curPublishAllArea:'全国',
            mentionAreaData:[],//提及地区
            entityList:[],//人物实体
            institEntityList:[],//机构实体
            // isShowMap:true,
            // isShowMention:false,
            curMentionArea:'top',
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            gapX:0,
            startx:0,
            endx:0,
            nodata:{
                hotTopicsList:false,
                emotionData2:false,
                defaultWords:false,
                hotEventData:false,
                mediaData:false,
                activeAccList:false,
                bloggerList:false,
                entityList:false,
                institEntityList:false,
                knowEntity:false,
            },
            load:{
                activeAccList:false,
            },
            icons:{
                '微信':'wx-icon',
                '网页':'web-icon',
                '微博':'wb-icon',
                '头条':'toutiao-icon',
            },
            mediaList:{'全部':4,'网页':1,'微信':2,'微博':3,'头条':5},//媒体列表
            commendList:[],//相关文章
            firNewsList:{
                name:'',
            },//首发文章
            viewList:[],
            scrollH:'auto',
            dsCharts:[],
            updateDsCharts:[],
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> { 
            that.dataAjax();
            that.timeAjax();
            that.hotThemeAjax();
            that.publishAreaAjax();
            that.mentionAreaAjax();
        }) 
    },
    methods: {
        showNewType(type,num){
            let that = this;
            for (let key in that.mediaList) {
                if(that.mediaList[key] == type){
                    if(num ==1){
                        return that.icons[key];
                    }else{
                        return key;
                    }
                }
            }
        },
         
        dataAjax(){
            let that = this;
            that.$parent.loadModal(true,'数据加载中...');
            let datas = {sid:that.sid,news_type:that.newsType,type:that.type,api_secret:that.apiSecret};
            //话题详情
            that.$api.get('news/info/info',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.infoList = r.data;
                    document.title = r.data.newsTitle+'_清博热点';
                });
            });
            //话题概括
            that.$api.get('news/info/hot-over-view',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.hotOver = r.data;
                });
            });
            //话题走势
            that.$api.get('news/info/hot-line-chart',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.hotEventData = r.data;
                    if(r.data.length<=0){
                        that.nodata.hotEventData = true;
                        return;
                    }else{
                        that.nodata.hotEventData = false;
                    }
                });
            });
            //媒体分析
            that.$api.get('news/info/hot-news-platform-pie',datas,r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.length<=0){
                        that.nodata.mediaData = true;
                        return;
                    }else{
                        that.nodata.mediaData = false;
                    }
                    that.mediaData = r.data;
                });
            });
            //活跃账号
            that.$api.get('monitor/analysis/platform',datas,r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.length<=0){
                        that.nodata.activeAccList = true;
                        return;
                    }else{
                        that.nodata.activeAccList = false;
                    }
                    that.activeAccTab = r.data;
                    for (let key in r.data) {
                        let ele = r.data[key];
                        that.curIndex = key;
                        that.activeAccAjax();
                        return
                    }
                });
            });
            //微博分析
            that.$api.get('news/info/weibo-analysis',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.wbAnalysisHtml.html = r.data.descHtml;
                    that.wbAnalysisHtml.artCount = r.data.articleCount;
                    that.wbAnalysisHtml.folCount = r.data.followersCount;
                    that.wbAnalysisHtml.effectMax = r.data.effectMaxType;
                    let wbData = {};
                    wbData.datetime = r.data.keyList;
                    wbData.dataName = ['辐射人群','参与数量'];console.log(wbData.data);
                    wbData.data=[];
                    wbData.data.push(r.data.followersNumList);
                    wbData.data.push(r.data.articleNumList);
                    that.wbAnalysisData = wbData;
                });
            });
            
            //情感属性
            that.$api.get('news/info/sentiment-pie',datas,r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.length<=0){
                        that.nodata.emotionData2 = true;
                        return;
                    }else{
                        that.nodata.emotionData2 = false;
                    }
                    that.emotionData2 = r.data;
                });
            });
            that.$api.get('news/info/sentiment-line',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.emotionData1 = r.data;
                });
            });
            // 首发文章
            that.$api.get('news/info/first-hotevent',datas,r=>{
                that.$parent.loadModal(false);
                that.$parent.returnCode(r,function(){
                    r.data[0].isLoadStart = false;
                    that.firNewsList = r.data[0];
                    that.firNewsList.createTime = that.filter(r.data[0].createTime);
                });
            });
            //人物实体
            that.$api.get('news/info/entity-analysis',datas,r=>{
                that.$parent.returnCode(r,function(){
                    let data = r.data;
                    if(data.length<=0){
                        that.nodata.entityList = true;
                        that.nodata.institEntityList = true;
                        return
                    }
                    that.entityList = data.person;
                    that.institEntityList = data.organization;
                    if(data.person.length<=0){
                        that.nodata.entityList = true;
                    }else{
                        that.nodata.entityList = false;
                    }
                    if(data.organization.length<=0){
                        that.nodata.institEntityList = true;
                    }else{
                        that.nodata.institEntityList = false;
                    }
                });
            });    
            //相关文章
            that.$api.get('news/info/relate-hotevent',datas,r=>{
				that.$parent.returnCode(r,function(){
					r.data.forEach(ele => {
                        ele.isLoadStart = false
                    });
					that.commendList = r.data;
				})
            });
            that.$axios.get('static/city.json').then((r) => {
                that.areaChoseList = r.data.shortProvince;
                that.provinceFullList = r.data.province;
            })
        },
        //时间脉络
        timeAjax(){
            let that = this;
            let datas = {sid:that.sid,news_type:that.newsType,type:that.type,perpage:100,api_secret:that.apiSecret};
            that.$api.get('news/info/timeline-desc',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.timeLineList  = r.data
               });
            });         
            
        },
        timeFilter(t){
            var newT = '';
            if(t!=null){
                let tmp = t.split(':');
                newT = tmp[0]+':'+tmp[1];
                return newT;
            }
        },
        // 情感属性图表切换
        emotionEchartTab(type) {
            this.tuType = type;
        },
        //活跃账号切换
        choseAccout(num){
            this.curIndex = num;
            this.activeAccAjax();
        },
        activeAccAjax(){
            let that = this;
            let data= {sid:that.sid,news_type:that.newsType,type:that.type,platform:that.curIndex,api_secret:that.apiSecret};
            that.activeAccList = [];
            that.nodata.activeAccList = false;
            that.load.activeAccList = true;
            that.$api.get('news/info/hot-news-media-top',data,r=>{
                that.$parent.returnCode(r,function(){
                    that.activeAccList = r.data;
                    that.load.activeAccList = false;
                    if(r.data.length<=0){
                        that.nodata.activeAccList = true;
                        return;
                    }else{
                        that.nodata.activeAccList = false;
                    }
                });
            });
        },
        wordClickHandler(name, value, vm) {
            console.log('wordClickHandler', name, value, vm);
        },
        // 热门主题词切换
        hotThemeTab (type) {
            this.hotThemeType = type;
            this.curHotTheme = this.mtType[type];
        },
        // 热门主题词
        hotThemeAjax () {
            let that = this;
            that.$api.get('news/info/hot-key-words',{sid:that.sid,news_type:that.newsType,type:that.type,api_secret:that.apiSecret},r=>{
                that.$parent.returnCode(r,function(){
                    if(r.data.length<=0){
                        that.nodata.defaultWords = true;
                        return;
                    }else{
                        that.nodata.defaultWords = false;
                    }
                    that.defaultWords = r.data;
                    that.hotThemePie = r.data.slice(0,20);
                    that.hotThemeRadar = r.data.slice(0,20);
                });
            });
        },
        // 发布地区
        getAreaType(data){
            let that = this;
            // if(that.curPublishArea ==="全国" && that.areaChoseList.length===0){
            //     //that.curMentionArea = data[0].name;               
            //     data.forEach(ele => {
            //         that.areaChoseList.push(ele.name);
            //     });
            //     that.areaChoseList.unshift("全国");
            // }
        },
        publishAreaAjax(){
            let that = this;
            let dataArgs = {sid:that.sid,news_type:that.newsType,type:that.type,api_secret:that.apiSecret};
            if(that.curPublishArea!="全国"){
                dataArgs.province = that.curPublishArea
            }
            that.$api.get('news/info/publish-area',dataArgs,r=>{
                that.$parent.returnCode(r,function(){
                    // that.publishAreaData = [];
                    // that.isShowMap = true;
                    // r.data.forEach((ele,index)=>{
                    //     if(ele.value == 0 && (index ==0)){
                    //         ele.value = '-';
                    //         that.publishAreaData.push(ele)
                    //         that.isShowMap = false;
                    //     }if(ele.value != 0){
                    //         that.publishAreaData.push(ele)
                    //     }
                    // });
                    that.publishAreaData = r.data;
                    that.getAreaType(r.data)
                });
            });
        },
        //提及地区
        mentionAreaAjax(){
            let that = this;
            let dataArgs = {sid:that.sid,news_type:that.newsType,type:that.type,api_secret:that.apiSecret};
            if(that.curMentionArea!="全国"){
                dataArgs.province = that.curMentionArea
            }
            that.$api.get('news/info/mention-area',dataArgs,r=>{
                that.$parent.returnCode(r,function(){
                    that.mentionAreaData = r.data.data;
                    // that.mentionAreaData = [];
                    // that.isShowMention = true;
                    // r.data.data.forEach((ele,index)=>{
                    //     if(ele.value == 0 && (index ==0)){
                    //         ele.value = '-';
                    //         that.mentionAreaData.push(ele)
                    //         that.isShowMention = false;
                    //     }else if(ele.value != 0){
                    //         that.mentionAreaData.push(ele)
                    //     }
                    // });
                    that.curMentionArea = r.data.topProvince;
                    that.getAreaType(r.data.data)
                });
            });
        },
        changeArea(name,type,index){
            let that = this;
            if(type==1){
                that.curPublishArea = that.provinceFullList[index];
                that.publishAreaAjax();
            }else{
                that.curMentionArea = that.provinceFullList[index];
                that.mentionAreaAjax();
            }
            
        },
        fatherMethod(name,id,type){
            let that = this;
            if(type!=3){
                if(id=="publishArea"){
                    that.curPublishArea = name;
                    that.publishAreaAjax();
                }else{
                    that.curMentionArea = name;
                    that.mentionAreaAjax();
                }
            }
        },
        
        loadImg(ele,i,item,len,imgUrls){
            let that= this;
            let img = new Image()
            img.src = ele
            img.onload = function () {
                if(img.width>200 && ((img.width/img.height)<3)){
                    item.curImg = ele;
                    item.isLoadStart = true;
                    //console.log(img.width/img.height)
                    return
                }
                if(i>=(len-1)){
                    item.curImg = '';
                    item.isLoadStart = true;
                    return 
                }
                that.loadImg(imgUrls[i+1],(i+1),item,len,imgUrls);
            }
        },
        imgChose(item,imgUrls){
            let that= this,len = imgUrls.length;
            if((len==1 && imgUrls[0]=='') || len==0){
                item.isLoadStart = true;
                item.curImg='';
                return;
            }
           that.loadImg(imgUrls[0],0,item,len,imgUrls); 
        },
        // 详情预览
        artiView(platName){
            let that = this;
            let query = {
                sid:that.sid,
                type:that.type,
                news_type:that.newsType,
                platform:that.curIndex,
                platform_name:platName,
                api_secret:that.apiSecret
            };
            that.viewList=[];
            that.$api.get('news/info/hot-news-media-top-info', query, r => {
                that.$parent.returnCode(r,function(){
                    let data = r.data;
                    that.$refs.viewModal.showMaskFun();
                    that.viewList = data;
                    if(data.length>5){
                        that.scrollH = '465px'
                    }else{
                        that.scrollH = data.length*80 + 'px'
                    }
                    if(data.length<=0){
                        that.nodata.viewList = true;
                    }else{
                        that.nodata.viewList = false;
                    }
                    
                })
            })
        },
        enterView(){
            let that = this;
            that.$refs.viewModal.closeMask();
        },
        //显示知识图谱
        showKnow(item){
            let that = this;
            that.dsCharts = [];
            that.nodata.knowEntity = false;
            that.$refs.knowModal.showMaskFun();
            that.getEntity(item);
        },
        getEntity(item){
            let that = this;
            let datas = {
                entity:item,
                sid:that.sid,
                type:that.type,
                news_type:that.newsType,
                api_secret:that.apiSecret
            };
            that.$api.get('news/info/knowledge-disambiguation',datas, r => {
                that.$parent.returnCode(r,function(){
                    let data = r.data;
                    if(data.length<=0){
                        if(that.dsCharts.length<=0){
                            that.nodata.knowEntity = true;
                        }
                        return;
                    }
                    let nodeJson = {
                        nodes:[],
                        links:[],
                    }
                    if(data[0][1]!=item){
                        nodeJson.nodes.push({name:item})
                    }
                    if(data.length>0){
                        data.forEach((ele,i) => {
                            if(ele[1] == '') return
                            let name = ele[1];
                            if(i>0 && ele[1] == data[i-1][1] ){
                                name = ele[1]+"("+ele[0] + ")"
                                //return
                            }
                            let tmp = {};
                            let tmp1 = {};
                            tmp.name = name;
                            tmp.id = ele[2];
                            nodeJson.nodes.push(tmp)
                            tmp1.source = item;
                            tmp1.target = name;
                            tmp1.relation = ele[0];
                            nodeJson.links.push(tmp1)
                        });
                    }
                     
                    that.dsCharts = nodeJson;
                })
            }) 
        },
        getEntityChild(item,id){
            let that = this;
            let datas = {
                node_id:id,
                api_secret:that.apiSecret
            };
            that.$api.get('news/knowledge/node-id',datas, r => {
                that.$parent.returnCode(r,function(){
                    let data = r.data;
                    let nodeJson = {
                        nodes:[],
                        links:[],
                    }
                    if(data.length>0){
                        data.forEach((ele,i) => {
                            if(ele[1] == '') return
                            let name = ele[1];
                            if(i>0 && ele[1] == data[i-1][1] ){
                                name = ele[1]+"("+ele[0] + ")"
                                //return
                            }
                            let tmp = {};
                            let tmp1 = {};
                            tmp.name = name;
                            tmp.id = ele[2];
                            nodeJson.nodes.push(tmp)
                            tmp1.source = item;
                            tmp1.target = name;
                            tmp1.relation = ele[0];
                            nodeJson.links.push(tmp1)
                        });
                    }
                    that.updateDsCharts = nodeJson;
                })
            }) 
        },
	}
}
</script>



// WEBPACK FOOTER //
// src/page/news/newsDetaildw.vue